export default __webpack_public_path__ + "static/media/Password.08457e5f.svg";